import { Col, Row } from "antd";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import { GET_STORE_REQUEST_URL, GET_STORE_UPDATE_REQUEST_URL } from "../../commons/constants/api-urls";
import { routerNavigation, routers } from "../../commons/constants/routers";
import useFetchList from "../../commons/hooks/useFetchList";
import { Store } from "../../commons/resources";
import StoreCard from "./StoreCard";
import styles from "./store-management.module.scss";
import { STORE_TYPE_TABS } from ".";
import { STORE_TYPE } from "../../commons/constants/store";

interface Props {
  activeTab: string;
  activeTypeTab: string;
}
const StorePending: React.FC<Props> = ({ activeTab, activeTypeTab }) => {
  const navigate = useNavigate();

  const onSelectStore = (store: StorePending) => {
    if (store.merchantStoreId) {
      navigate(routerNavigation.STORES.STORE_DASHBOARD(store.merchantStoreId));
    }
  };

  const { data: createStore, loading: loadingCreateStore } = useFetchList<StorePending>(GET_STORE_REQUEST_URL, {
    pageSize: 100,
    perPage: 100,
  });

  const { data: updateStore, loading: loadingUpdateStore } = useFetchList<StorePending>(GET_STORE_UPDATE_REQUEST_URL, {
    pageSize: 100,
    perPage: 100,
  });

  const loading = loadingCreateStore || loadingUpdateStore;

  const listStore = useMemo(() => {
    const returnData = [...createStore, ...updateStore];
    if (activeTypeTab === STORE_TYPE_TABS.ALL) {
      return returnData;
    }

    let storeType: string = STORE_TYPE.FOOD_DELIVERY;
    switch (activeTypeTab) {
      case STORE_TYPE_TABS.FOOD_DELIVERY:
        storeType = STORE_TYPE.FOOD_DELIVERY;
        break;
      case STORE_TYPE_TABS.SURPLUS:
        storeType = STORE_TYPE.SURPLUS;
        break;

      default:
        break;
    }

    return returnData.filter(item => item.type && item.type === storeType);
  }, [activeTypeTab, createStore, updateStore]);

  return (
    <div>
      {!loading ? (
        listStore.length === 0 ? (
          <div className={styles.emptyList}>
            <img className={styles.image} src={Store} alt="store" />
            <div className={styles.title}>Looks like there’s nothing pending.</div>
            <div className={styles.description}>Everything’s been reviewed</div>
            <PrimaryButton className={styles.createStoreBtn} onClick={() => navigate(routers.STORES.CREATE_STORE)}>
              Create store
            </PrimaryButton>
          </div>
        ) : (
          <>
            {/* <div className={styles.stores}> */}
            <Row gutter={[24, 12]} style={{ marginTop: 30 }}>
              {listStore.map((store: StorePending, index: number) => (
                <Col key={store.id} span={6} lg={6} md={12} xs={24}>
                  <StoreCard
                    key={index}
                    storeName={store.name}
                    image={store.logo}
                    onClick={() => onSelectStore(store)}
                    type={store.storePendingtype}
                    storeType={store.type as STORE_TYPE}
                  />
                </Col>
              ))}
            </Row>
            {/* </div> */}
          </>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default StorePending;
